import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"


import { FieldType } from '@/types';
import Input from './Input.vue';
import DropdownInput from './DropdownInput.vue';
import AutocompleteInput from './AutocompleteInput.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
    field: null,
    modelValue: null
  },
  emits: ["update:modelValue"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (__props.field.type === 'input')
    ? (_openBlock(), _createBlock(Input, {
        key: 0,
        "model-value": __props.modelValue,
        title: __props.field.title,
        "input-key": __props.field.key,
        placeholder: __props.field.placeholder,
        unit: __props.field.unit,
        "input-pattern": __props.field.inputPattern,
        "input-mode": __props.field.inputMode,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
      }, null, 8, ["model-value", "title", "input-key", "placeholder", "unit", "input-pattern", "input-mode"]))
    : (__props.field.type === 'dropdown')
      ? (_openBlock(), _createBlock(DropdownInput, {
          key: 1,
          "model-value": __props.modelValue,
          title: __props.field.title,
          "input-key": __props.field.key,
          options: __props.field.values,
          "translate-title": __props.field.translateTitle,
          "allow-all": __props.field.allowAll,
          hint: __props.field.hint,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
        }, null, 8, ["model-value", "title", "input-key", "options", "translate-title", "allow-all", "hint"]))
      : (__props.field.type === 'inputAutocomplete')
        ? (_openBlock(), _createBlock(AutocompleteInput, {
            key: 2,
            "model-value": __props.modelValue,
            title: __props.field.title,
            "input-key": __props.field.key,
            options: __props.field.options,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:modelValue', $event)))
          }, null, 8, ["model-value", "title", "input-key", "options"]))
        : _createCommentVNode("", true)
}
}

})